import { ref } from "vue";

const answers = ref({});

const useAnswers = () => {
  return { answers };
};

export default useAnswers;
